import { useEffect, useState } from 'react';

import styles from './Stepper.module.css';

type StepperProps = {
  prevStep: number;
  currentStep: number;
  totalSteps: number;
};

const getPos = (curVal: number, totalVal: number) =>
  `${Math.round((curVal / (totalVal + 1)) * 100)}%`;

export default function Stepper({
  prevStep,
  currentStep,
  totalSteps,
}: StepperProps) {
  const [topPos, setTopPos] = useState(() => getPos(prevStep, totalSteps));
  useEffect(() => {
    // Deliberate mount-time transition trick: the initial render paints at
    // the *previous* step's position (seeded above), then this effect
    // updates topPos to the current step immediately after that paint so
    // the CSS `top` transition animates from prevStep to currentStep.
    // Computing topPos from currentStep directly during render would skip
    // the initial paint at prevStep and the transition wouldn't animate.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setTopPos(getPos(currentStep, totalSteps));
  }, [currentStep, totalSteps]);

  return (
    <div
      className={styles['stepper-container']}
      data-testid="stepper-container"
    >
      <span
        className={styles['stepper-indicator']}
        style={{ top: topPos }}
        data-testid="stepper-indicator"
      />
    </div>
  );
}
